import { get } from 'lodash';
import { Button, Form } from 'react-bootstrap';
import { useFieldArray } from 'react-hook-form';
import { ParcelNumber } from './ParcelNumber';

export const ParcelNumberRepeater = ({ prefix, register, control, error }) => {
	const name = prefix ? prefix + '.parcelNumbers' : 'parcelNumbers';

	const { fields, append, remove } = useFieldArray({ name, control });

	const addParcelNumber = () => {
		append({ parcelNumber: undefined });
	};

	const handleRemove = id => {
		remove(id);
	};

	const createParcelNumber = ({ parcelNumber }, id) => (
		<div key={id}>
			<ParcelNumber
				registerName={`${name}.${id}.parcelNumber`}
				id={id}
				onRemove={handleRemove}
				enableRemove={id === 0 ? false : true}
				value={parcelNumber}
				register={register}
			/>
			<Form.Text className="text-danger">
				{get(error, `${name}.${id}.parcelNumber.message`)}
			</Form.Text>

			{id < fields.length - 1 ? <hr /> : null}
		</div>
	);

	return (
		<div>
			{fields.map(createParcelNumber)}
			<Button
				variant="outline-secondary"
				size="lb"
				className="mt-2 col-md-3 float-right"
				onClick={addParcelNumber}
				block>
				Add parcel number
			</Button>
		</div>
	);
};
